// extracted by mini-css-extract-plugin
module.exports = {"questionAnswers":"styles_questionAnswers__5H_Lz","listItem":"styles_listItem__W5Q92","question":"styles_question__d8no7","answer":"styles_answer___A_y2"};